import React, { Component } from 'react'
import { Button, Modal, Input, message } from 'antd';
import Text from '../../basicElement/Text';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

export default class UpdataModal extends Component {
    state = {
        visible: false,
        type: 'add',
        record:{},
        error: false,
        identifyCode:null,
    }

    show = ( record, type ) => {
        this.setState({ 
            visible: true, 
            record, 
            type, 
            identifyCode:type == 'add' ? null : record.identifyCode
        })
    }
    
    confirm = () => {
        const { record, identifyCode, type } = this.state;
        const { investigationIdentifyCodeId = null } = record;
        if(!identifyCode) {
            message.error('请输入项目识别码！')
            return
        }
        const options = {
            method: 'POST',
            url: API_URL.contract.saveInvIdentifyCode,
            data: {
                identifyCode,
                investigationIdentifyCodeId,
            },
            dataType: 'json',
            doneResult: res => {
                if( res.error ) {
                    this.setState({ error: true });
                    return
                }
                message.success(res.success);
                this.hide();
                this.props.loadData();
            }
        };
        $.sendRequest(options);
    }

    hide = () => {
        this.setState({ 
            visible: false,
            type: 'add',
            record:{},
            error: false,
            identifyCode:null,
        })
    }

    handleChange = (value) => {
        this.setState({ identifyCode: value } )
    }

    render() {
        const { visible, identifyCode, type, error } = this.state;
        return (
            <Modal 
                title={`${type == 'add' ? '添加' : '修改'}项目识别码`}
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
            >
                <div className='updataModal'>
                    <div className="form-list">
                        <div className="form-item">
                            <label htmlFor="" className="ui-label"><Text asterisk={true} colon={true}>项目识别码</Text></label>
                            <div className='ui-text'>
                                <Input value={identifyCode} onChange={ e => this.handleChange(e.target.value)} placeholder={'请输入'}/>
                                {
                                    error && <div style={{color: 'red'}}>项目识别码已存在</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/contractManagement/IdentificationCode/UpdataModal.js